<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-form ref="form" v-model="valid" :lazy-validation="lazy" id="supportForm">
    <DialogSendEMail ref="dialog"/>
    <v-container class="pt-0" v-if="isSend">
      <v-layout row wrap justify-center>
        <v-flex xs12>
          <v-card flat color="white">
            <v-icon large color="#004884" class="mt-5">done</v-icon>
            <v-card-title class="headline font-weight-thin bluetext mt-3 pb-0 pt-0">
              <v-spacer></v-spacer>
              {{'TITLE_CONTACT_SUPPORT_MAIL_SEND' | translate}}
              <v-spacer></v-spacer>
            </v-card-title>
            <v-card-title class="body-1 font-weight-thin bluetext text-xs-left py-2 mt-3">
              {{'SUBTITLE_CONTACT_SUPPORT_MAIL_SEND' | translate}}
            </v-card-title>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue" dark small class="font-weight-bold text-none" @click="doCancel()">
                {{'BUTT_OK' | translate}}
              </v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
    <v-container class="pt-0" v-if="!isSend">
      <v-layout row wrap justify-center>
        <v-flex xs12>
          <v-card flat color="white">
            <v-card-title class="headline font-weight-thin bluetext mt-1 pb-0 pt-0">
              {{'TITLE_CONTACT_SUPPORT' | translate}}
            </v-card-title>
            <v-card-title class="body-1 font-weight-thin bluetext text-xs-left py-2">
              {{'SUBTITLE_CONTACT_SUPPORT' | translate}}
            </v-card-title>
          </v-card>
        </v-flex>
        <v-flex xs12>
          <v-card flat color="transparent">
            <v-layout wrap row justify-space-between>
              <v-flex
                xs12
                class="px-2"
              >
                <v-select
                  :items="items"
                  :label="subject"
                  v-model="formData.subject"
                  :rules="[rules.required]"
                  solo
                  class="heightLogin"
                  required
                ></v-select>
              </v-flex>
            </v-layout>

            <v-layout wrap row justify-space-between>
              <v-flex
                xs12
                class="px-2"
              >
                <v-text-field solo class="heightLogin"
                              :label="subjectmatter"
                              v-model="formData.subjectmatter"
                              :rules="[rules.required]"
                              required>
                </v-text-field>
              </v-flex>
            </v-layout>


            <v-flex
              xs12
              sm12
              class="px-2"
            >
              <v-textarea
                solo
                class="heightLogin"
                v-model="formData.nachricht"
                :rules="[rules.required]"
                :label="yourmessage"
              ></v-textarea>
            </v-flex>
            <!--<v-layout row class="mb-3">
              <v-flex xs12>
                <v-checkbox
                  :rules="[rules.required]"
                  color="#004884"
                  v-model="formData.agree"
                  hide-details
                >
                  <template v-slot:label>
                    <div>
                      {{'CHECKBOX_LEGALNOTICE1' | translate}}
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                          <a
                            target="_blank"
                            href="https://www.creditreform.de/datenschutz"
                            @click.stop
                            v-on="on"
                          >
                            {{'LEGALNOTICE' | translate}}
                          </a>
                        </template>
                        {{'TOOLTIP_LEGALNOTICE' | translate}}
                      </v-tooltip>
                      {{'CHECKBOX_LEGALNOTICE2'| translate}}
                      <a
                        href="mailto:info@creditreform-rating.de"
                        @click.stop
                      >
                        {{'EMAIL_LEGALNOTICE' | translate}}
                      </a>
                      {{'CHECKBOX_LEGALNOTICE3'| translate}}
                    </div>
                  </template>


                </v-checkbox>


              </v-flex>
            </v-layout>
            <vue-recaptcha @verify="onVerify"
                           size="invisible"
                           @expired="onExpired" ref="invisibleRecaptcha"
                           sitekey="6LfIobcUAAAAAIOAvpfcwwDtoDExve5s3Tpwgh-4" :loadRecaptchaScript="true">
            </vue-recaptcha>-->
            <v-card-title v-if="isSubjectThree()" class="body-1 font-weight-thin bluetext text-xs-left py-2">
              {{'SUBTITLE_CONTACT_SUPPORT_UPLOAD' | translate}}
            </v-card-title>
            <v-flex
              xs12
              v-if="isSubjectThree()"
              sm12
              class="px-2 mb-0"
            >
              <v-text-field
                :label="uploadselect"
                solo class=""
                color="#004884"
                @click='onPickFile'
                clearable
                v-model="fileName"
                prepend-inner-icon="attach_file"
              ></v-text-field>
              <!-- Hidden -->
              <input
                type="file"
                @change="onFilePicked"
                style="display: none"
                ref="fileInput"
                accept="*/*"/>
            </v-flex>
            <v-radio-group v-model="formData.watype" row v-if="isSubjectThree()" class="ml-3 marginTopminus15">
              <v-radio :label="radioPrivate" value="private" color="#004884"></v-radio>
              <v-radio :label="radioPublic" value="public" color="#004884"></v-radio>
            </v-radio-group>
            <v-card-actions>
              <v-layout>
                <v-btn color="blue" dark small class="font-weight-bold text-none" @click="doCancel()">
                  {{'BUTT_CANCEL' | translate}}
                </v-btn>
                <v-spacer></v-spacer>
                <v-btn color="blue" dark small class="font-weight-bold text-none" @click="onSubmit()">
                  {{'BUTT_SEND' | translate}}
                </v-btn>
              </v-layout>
            </v-card-actions>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </v-form>
</template>

<script>
  import Vue from 'vue'
  import DialogSendEMail from './../module/dialogs/DialogSendEMail'

  export default {
    name: 'ContactForm_Support',
    components: {DialogSendEMail},
    data() {
      return {
        formData: {
          subject: '',
          subjectmatter: '',
          nachricht: '',
          file: null,
          watype: null,
        },
        mailto: Vue.i18n.translate('EMAIL_SUPPORT'),
        valid: true,
        isSend: false,
        menu: false,
        lazy: false,
        fileName: '',
        url: '',
        fileObject: null,
        cardResult: '',
        uploadselect: Vue.i18n.translate('UPLOAD_SELECT'),
        radioPrivate: Vue.i18n.translate('RADIO_PRIAVTE'),
        radioPublic: Vue.i18n.translate('RADIO_PUBLIC'),
        subject: Vue.i18n.translate('SUBJECT'),
        subjectmatter: Vue.i18n.translate('SUBJECT_MATTER'),
        yourmessage: Vue.i18n.translate('FORM_YOURMESSAGE'),
        items: [],
        rules: {
          required: value => !!value || Vue.i18n.translate('FORM_REQUIRED')
        }
      }
    },
    methods: {
      isSubjectThree: function () {
        return false
      },
      goPortal: function () {
        this.$router.push('/Login')
      },
      onClick: function () {
        window.history.back()
      },
      doCancel: function () {
        Vue.prototype.$api.debug('doCancel')
        this.isSend = false
        this.formData = {
          subject: '',
          subjectmatter: '',
          nachricht: '',
          file: null,
          watype: null,
        }
        this.$emit('cancel')
      },
      onSubmit: function () {
        if (!this.$refs.form.validate()) {
          Vue.prototype.$api.debug('missing values')
          return
        }
        Vue.prototype.$api.debug('doSend')
        this.onVerify('noCaptcha')
      },
      onSend: function (data) {
        Vue.prototype.$api.debug('onSend', data)
        Vue.prototype.$api.hideIdle()
        this.isSend = true
      },
      onVerify: function (response) {
        Vue.prototype.$api.debug('Verify: ' + this.fileObject)
        Vue.prototype.$api.showIdle()
        Vue.prototype.$api.sendSupportRequest(window.jQuery('#supportForm')[0], this.formData, this.fileObject, this.onSend, this.mailto)
      },
      onRegister: function () {
        this.$refs.dialog.open()
      },
      onExpired: function () {
        Vue.prototype.$api.debug('Expired')
      },
      resetRecaptcha() {
        this.$refs.recaptcha.reset() // Direct call reset method
      },
      onPickFile() {
        this.$refs.fileInput.click()
      },
      onFilePicked(event) {
        const files = event.target.files
        if (files[0] !== undefined) {
          this.fileName = files[0].name
          // Check validity of file
          if (this.fileName.lastIndexOf('.') <= 0) {
            return
          }
          // If valid, continue
          const fr = new FileReader()
          fr.readAsDataURL(files[0])
          fr.addEventListener('load', () => {
            this.url = fr.result
            this.fileObject = files[0] // this is an file that can be sent to server...

          })
        } else {
          this.fileName = ''
          this.fileObject = null
          this.url = ''
        }
      },
      onUploadSelectedFileClick() {
        this.loading = true

        Vue.prototype.$api.debug(this.fileObject)
        // A file is not chosen!
        if (!this.fileObject) {
          alert('No file!!')
        }
      },
      open () {
        this.formData.watype = 'private'
        this.isSend = false
        let index = 1
        this.items = []
        const moduleId = Vue.prototype.$api.getModuleId()
        this.mailto = Vue.prototype.$api.getSupportEmail(true)
        while (index < 100) {
          let key = 'SUPPORT_SUBJECT_' + index
          if (moduleId && (moduleId !== 'unknown')) {
            key = key + '_' + moduleId
          }
          console.log('key', key)

          var str = Vue.i18n.translate(key)
          if (str && str.length > 0 && str !== key) {
            this.items.push(str)
          } else {
            break
          }
          index++
          // Vue.i18n.translate('SUBJECT_ONE'), Vue.i18n.translate('SUBJECT_TWO'), Vue.i18n.translate('SUBJECT_THREE')
        }
      }
    },
    mounted() {
      this.open()
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/widgets/ContactForm_Support.vue